export default __webpack_public_path__ + "static/media/DanskeNarrowSemibold.c30a8553.ttf";